import {Button, Stack} from "@mui/material";
import {Link as RouterLink} from "react-router";
import React from "react";
import PATH from "../../routing/routes";
import ParallelLines from "../ParalelLines";

const DesktopMenu = () => {
    return (
        <Stack direction="row" width="100%" spacing={1} alignItems="end">
            <ParallelLines/>

            <Button
                to={PATH.HOME}
                component={RouterLink}
                sx={{
                    "&:hover": {
                        color: "primary.light",
                    }
                }}>
                Despre Noi
            </Button>

            <Button
                to={PATH.CAMPS_CLASSICS}
                component={RouterLink}
                sx={{
                    "&:hover": {
                        color: "primary.light",
                    }
                }}>
                Tabere de limbi clasice
            </Button>

            <Button
                to={PATH.CAMPS_ENGLISH}
                component={RouterLink}
                sx={{
                    "&:hover": {
                        color: "primary.light",
                    }
                }}>
                Tabere de limba engleză
            </Button>

            <Button
                to={PATH.CONTACT}
                component={RouterLink}
                sx={{
                    "&:hover": {
                        color: "primary.light",
                    }
                }}>
                Contact
            </Button>

            <ParallelLines/>
        </Stack>
    );
};

export default DesktopMenu;